<template>
    <component :is="tagName" :class="classes">
        <button v-if="!modToggle" class="kl-ol-map-base-layer__more" @click="toggleBaseLayer">
            <vl-icon class="kl-ol-map-base-layer__more__icon" icon="nav-left" />
        </button>
        <slot/>
    </component>
</template>

<script src="./kl-ol-map-base-layer.ts"></script>
